'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = {
    data: function data() {

        return {
            is_expanded: false
        };
    },

    props: ['sectionTitle', 'image', 'authorName', 'excerpt', 'text', 'readAll'],
    methods: {
        process_click: function process_click(event) {
            this.is_expanded = true;
        }
    }
};
if (module.exports.__esModule) module.exports = module.exports.default
;(typeof module.exports === "function"? module.exports.options: module.exports).template = "\n<section class=\"testimony\">\n    <h2 class=\"testimony__title title title--h2\">{{ sectionTitle }}</h2>\n    <div class=\"testimony__citation\">\n        <img :src=\"image\" alt=\"\" class=\"testimony__picture\">\n        <p class=\"testimony__author\">{{ authorName }}</p>\n        <blockquote class=\"testimony__excerpt\">\n            {{{ excerpt }}}\n        </blockquote>\n    </div>\n    <article class=\"testimony__text\" v-bind:class=\"{'testimony__text--open':is_expanded}\">\n        {{{ text }}}\n    </article>\n    <div class=\"testimony__rm-wrap\" v-bind:class=\"{'testimony__rm-wrap--open':is_expanded}\">\n        <span class=\"link\" @click=\"process_click\">{{ readAll }}</span>\n    </div>\n</section>\n"
if (module.hot) {(function () {  module.hot.accept()
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), true)
  if (!hotAPI.compatible) return
  if (!module.hot.data) {
    hotAPI.createRecord("_v-806ba616", module.exports)
  } else {
    hotAPI.update("_v-806ba616", module.exports, (typeof module.exports === "function" ? module.exports.options : module.exports).template)
  }
})()}